import React, { FC } from 'react';
import classNames from 'classnames';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';
import {
  ExpertCellComponent,
  SubjectCellComponent,
  SubmittedCellComponent,
} from '../../QAndASellerContainer.component';
import useManageQuestion from '../../hooks/useManageQuestion';
import { isQuestionAnswerApproved } from 'router/subrouters/DataRoom/utils';
import { PRIORITY_ICONS } from 'router/subrouters/DataRoom/providers/QAndA/QAndA.provider';

import './QAndAMobileCard.styles.scss';

type QAndAMobileCardProps = {
  className?: string;
  question: Question;
};

const QAndAMobileCard: FC<QAndAMobileCardProps> = ({ className, question }) => {
  const { assignedUsernames, status, priority, submittedDate } = question;

  const isHighlighted =
    !assignedUsernames.length && !isQuestionAnswerApproved(status);

  const { YourDrawer, cantManageQuestion, onManageClick } =
    useManageQuestion(question);

  const classes = classNames(
    'q-and-a-mobile-card',
    { highlighted: isHighlighted, clickable: !cantManageQuestion },
    className,
  );

  return (
    <>
      <div
        className={classes}
        onClick={() => {
          if (cantManageQuestion) return;
          onManageClick();
        }}
      >
        <SubjectCellComponent question={question} />
        <div className="q-and-a-mobile-card__row">
          {PRIORITY_ICONS[priority]}
          <ExpertCellComponent question={question} />

          {!!submittedDate && (
            <>
              <div className="q-and-a-mobile-card__dot" />
              <SubmittedCellComponent question={question} />
            </>
          )}
        </div>
      </div>
      {!cantManageQuestion && YourDrawer}
    </>
  );
};

export default QAndAMobileCard;
